import styles from './RequestSection.module.css';
import logo from '../../../../assets/images/event/seniorhelper-logo.png';

/* 서비스 신청 외부 URL — 확정 시 아래 값을 변경하세요 */
const REQUEST_URL = '#';

function RequestSection() {
  return (
    <section className={styles.section}>
      <a
        className={styles.requestBtn}
        href={REQUEST_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        서비스신청
      </a>
      <p className={styles.name}>어르신 전용 심부름센터</p>
      <div className={styles.logoRow}>
        <img src={logo} alt="시니어헬퍼 로고" className={styles.logoImg} />
        <a href="tel:15333940" className={styles.phoneNumber}>1533-3940</a>
      </div>
    </section>
  );
}

export default RequestSection;
